<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<ul class="nav nav-tabs" role="tablist">
  <li class="active" (click)="setScreen('zero_canc')"><a href="#zero_cancellation" role="tab" data-toggle="tab">Zero
      Cancellation</a></li>
  <li><a href="#domestic" role="tab" data-toggle="tab" (click)="setScreen('ti_dom')">Travel Insurance - Domestic</a>
  </li>
  <li><a href="#international" role="tab" data-toggle="tab" (click)="setScreen('ti_int')">Travel Insurance -
      International</a></li>
</ul>

<div class="tab-content">
  <div class="tab-pane active" id="zero_cancellation"></div>
  <div class="tab-pane" id="domestic"></div>
  <div class="tab-pane" id="international"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin">
          <button class="btn btn-primary commonbutt" type="button" (click)="submitcancelData()" [disabled]="!validflag">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm(false)" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 2% 2% 2%">
                  <div class="col-lg-3" *ngIf="screen_name!='zero_canc'">
                    <label>Trip Type</label>

                    <select class="form-control" [(ngModel)]="screen_details.Trip_Type"
                      (change)="blank_check('Trip_Type')">
                      <option value="" disabled>--Select Trip Type --</option>
                      <option>One Way</option>
                      <option>Return</option>
                    </select>
                    <div class="err" id="Trip_Type_err" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3" *ngIf="screen_name!='ti_dom'">
                    <label>Travel Start Day</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Travel_Start_Date"
                      (blur)="num_check('Travel_Start_Date')" placeholder="Enter Travel Start Day" maxlength="3">
                    <div class="err" id="Travel_Start_Date_err" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3" *ngIf="screen_name!='ti_dom'">
                    <label>Travel End Day</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Travel_End_Date"
                      (blur)="num_check('Travel_End_Date')" placeholder="Enter Travel End Day" maxlength="3">
                    <div class="err" id="Travel_End_Date_err" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3">
                    <label>Cost Price</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Cost_Price "
                      (blur)="num_check('Cost_Price');checkLimit('Cost_Price',0);set_cost_price_without_gst()"
                      placeholder="Enter Cost Price" maxlength="4" disabled>
                    <div class="err nonmandat" id="Cost_Price_err" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3">
                    <label>Cost Price without GST</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Cost_Price_No_GST "
                      placeholder="" disabled>
                    <div class="err nonmandat" id="Cost_Price_No_GST_err" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3">
                    <label>Mark Up (%)</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Mark_Up"
                      (input)="num_check('Mark_Up');checkLimit('Mark_Up',0,100);allowBlank('Mark_Up')"
                      placeholder="Enter Mark Up" maxlength="3">
                    <div class="err nonmandat" id="Mark_Up_err" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3">
                    <label>Ploughback (%)</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Ploughback"
                      (blur)="decimal_check('Ploughback');checkLimit('Ploughback',0,100)" placeholder="Enter Ploughback"
                      maxlength="4">
                    <div class="err" id="Ploughback_err" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3">
                    <label>RPM</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.RPM"
                      (blur)="decimal_check('RPM');checkLimit('RPM',0,999)" placeholder="Enter RPM" maxlength="4">
                    <div class="err" id="RPM_err" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3">
                    <label>Commission (%)</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Commission"
                      (blur)="decimal_check('Commission');checkLimit('Commission',0,100)" placeholder="Enter Commission"
                      maxlength="4">
                    <div class="err" id="Commission_err" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3" *ngIf="screen_name!='zero_canc'">
                    <label>Insurance Provider</label>
                    <select class="form-control" [(ngModel)]="screen_details.Insurance_Provider"
                      (change)="blank_check('Insurance_Provider')">
                      <option value="" selected disabled>--Select Insurance Provider--</option>
                      <option *ngFor="let provider of providers" value={{provider.map_id}}>
                        {{provider.value}}
                      </option>
                    </select>
                    <div class="err" id="Insurance_Provider_err" style="height:30px"></div>
                  </div>

                  <div *ngIf="editFlag==true" class="col-lg-12">
                    <button class="btn btn-danger  commonbutt color" type="button" (click)="deleteDataConfirm()">
                      <em class="fa fa-trash"></em>&nbsp;
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- view Details -->
<div [hidden]="!viewpage" class="tdive">
  <div *ngIf="actionmode == 'view'" class="searchdiv">
    <div class="card screen-wrapper">
      <div style="border-bottom:1px solid #ddd9d9;margin-bottom: 15px; ">
        <h4 class="screen-title">{{ screentitle }}</h4>
        <div class="button-wrapper bothbuttdiv2">

          <button style="margin-top: 8px" class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <table aria-describedby="insuranceMasterData" class="viewtable">
      <div *ngFor="let q of EditData">
        <tr *ngIf="screen_name!='zero_canc'">
          <th scope="col"><span class="vlbl"> Trip Type </span></th>
          <td><span class="vVal">{{ q.TRIP_TYPE }}</span></td>
        </tr>
        <tr *ngIf="screen_name!='ti_dom'">
          <th scope="col"><span class="vlbl"> Travel Start Day</span></th>
          <td><span class="vVal">{{ q.TRAVEL_START }}</span></td>
        </tr>
        <tr *ngIf="screen_name!='ti_dom'">
          <th scope="col"><span class="vlbl"> Travel End Day</span></th>
          <td><span class="vVal">{{ q.TRAVEL_END }}</span></td>
        </tr>
        <tr>
          <th scope="col"><span class="vlbl"> Cost Price </span></th>
          <td><span class="vVal">{{ q.COST_PRICE }}</span></td>
        </tr>
        <tr>
          <th scope="col"><span class="vlbl"> Cost Price w/o GST </span></th>
          <td><span class="vVal">{{ q.COST_PRICE_NO_GST }}</span></td>
        </tr>
        <tr>
          <th scope="col"><span class="vlbl"> Mark Up (%) </span></th>
          <td><span class="vVal">{{ q.MARKUP }}</span></td>
        </tr>
        <tr>
          <th scope="col"><span class="vlbl"> Selling Price </span></th>
          <td><span class="vVal">{{ round(q.COST_PRICE+(q.COST_PRICE*q.MARKUP/100)) }}</span></td>
        </tr>
        <tr>
          <th scope="col"><span class="vlbl"> Commission (%) </span></th>
          <td><span class="vVal">{{ q.COMMISSION }}</span></td>
        </tr>
        <tr>
          <th scope="col"><span class="vlbl"> Commission Amount </span></th>
          <td><span class="vVal">{{ round(q.COST_PRICE_NO_GST*q.COMMISSION/100) }}</span></td>
        </tr>
        <tr>
          <th scope="col"><span class="vlbl"> Ploughback (%) </span></th>
          <td><span class="vVal">{{ q.PLOUGHBACK }}</span></td>
        </tr>
        <tr>
          <th scope="col"><span class="vlbl"> RPM </span></th>
          <td><span class="vVal">{{ q.RPM }}</span></td>
        </tr>
        <tr>
          <th scope="col"><span class="vlbl"> Miles Issued </span></th>

          <td><span class="vVal">{{ getMilesValue(q.COST_PRICE_NO_GST,q.COMMISSION, q.PLOUGHBACK, q.RPM) }}</span></td>
        </tr>
        <tr *ngIf="screen_name!='zero_canc'">
          <th scope="col"><span class="vlbl"> Insurance Provider </span></th>
          <td><span class="vVal">{{ getInsProvider(q.INSURANCE_PROVIDER) }}</span></td>
        </tr>

      </div>
    </table>
  </div>
</div>
<!-- End -->
<div [hidden]="viewpage" *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>Insurance Search</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" type="button" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div class="wr15">
                    <div class="instruct">
                      <div class="int1" style="margin-left: 17px">
                        <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                        <br />

                        <span class="txt">
                          1. Select at least one value out of
                          <span *ngIf="screen_name!='ti_dom'"> Travel Start Day, Travel End Day, Cost Price.</span>
                          <span *ngIf="screen_name=='ti_dom'"> Trip Type.</span>

                        </span>
                        <br />
                        <span class="txt" *ngIf="screen_name!='ti_dom'">
                          2. You can also use a combination of the given fields to search </span>
                        <br />
                        <span></span>
                      </div>
                    </div>
                    <div class="col-lg-3" *ngIf="screen_name=='ti_dom'">
                      <label>Trip Type</label>
                      <select class="form-control" [(ngModel)]="search_details.Trip_Type">
                        <option value="" disabled>--Select Trip Type --</option>
                        <option>One Way</option>
                        <option>Return</option>
                      </select>
                      <div class="search_err" id="Trip_Type"></div>
                    </div>
                    <div class="col-lg-3" *ngIf="screen_name!='ti_dom'">
                      <label>Travel Start Day</label>
                      <input type="text" class="form-control m-input" [(ngModel)]="search_details.Travel_Start_Date"
                        placeholder="Enter Travel Start Day">
                      <div class="search_err" id="Travel_Start_Date"></div>
                    </div>
                    <div class="col-lg-3" *ngIf="screen_name!='ti_dom'">
                      <label>Travel End Day</label>
                      <input type="text" class="form-control m-input" [(ngModel)]="search_details.Travel_End_Date"
                        placeholder="Enter Travel End Day">
                      <div class="search_err" id="Travel_End_Date"></div>
                    </div>
                    <div class="col-lg-3" *ngIf="screen_name!='ti_dom'">
                      <label>Cost Price</label>
                      <input type="text" class="form-control m-input" [(ngModel)]="search_details.Cost_Price"
                        placeholder="Enter Cost Price">
                      <div class="search_err" id="Cost_Price"></div>
                    </div>

                    <div class="btn clear-button button-margin">
                      <button style="margin-top: 20px;" class="btn btn-primary commonbutt" (click)="searchData()"
                        type="button">
                        <em class="fa fa-search "></em>&nbsp;Search
                      </button>
                    </div>
                  </div>
                  <br />

                  <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">
                    <table aria-describedby="insuranceTripMaster" class="table table-striped" [mfData]="searchtabledata"
                      [mfRowsOnPage]="5">
                      <tr>
                        <th scope="col" style="width: 7%">Action</th>
                        <th scope="col" *ngIf="screen_name!='zero_canc'"> Trip Type </th>
                        <th scope="col" *ngIf="screen_name!='ti_dom'"> Travel Start Day</th>
                        <th scope="col" *ngIf="screen_name!='ti_dom'"> Travel End Day</th>
                        <th scope="col"> Cost Price </th>
                        <th scope="col"> Mark Up (%) </th>
                        <th scope="col"> Selling Price </th>
                        <th scope="col"> Commission (%) </th>
                        <th scope="col"> Miles Issued </th>
                      </tr>
                      <tr *ngFor="let q of (searchtabledata
                        | paginate: { itemsPerPage: 10, currentPage: p })">
                        <td>
                          <button class="btn btn-default btn-circle" type="button" (click)="showFormData(q,1)">
                            <em class="fa fa-eye"></em>
                          </button>

                          <button class="btn btn-default btn-circle" type="button" (click)="showFormData(q,2)">
                            <em class="fa fa-pencil"></em>
                          </button>

                        </td>
                        <td *ngIf="screen_name!='zero_canc'">
                          <span class="vVal">{{ q.TRIP_TYPE }}</span>
                        </td>
                        <td *ngIf="screen_name!='ti_dom'">
                          <span class="vVal">{{ q.TRAVEL_START }}</span>
                        </td>
                        <td *ngIf="screen_name!='ti_dom'">
                          <span class="vVal">{{ q.TRAVEL_END }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ q.COST_PRICE }}</span>
                        </td>

                        <td>
                          <span class="vVal">{{ q.MARKUP }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ round(q.COST_PRICE+(q.COST_PRICE*q.MARKUP/100)) }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ q.COMMISSION }}</span>
                        </td>

                        <td>
                          <span class="vVal">{{getMilesValue(q.COST_PRICE_NO_GST,q.COMMISSION, q.PLOUGHBACK,
                            q.RPM)}}</span>
                        </td>

                      </tr>
                      <tfoot>
                        <tr>
                          <td colspan="4">
                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div *ngIf="loader">
                    <div style="margin:auto; text-align: center">
                      <img
                        src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                        width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- custom msg -->
<button class="btn-pnr" data-toggle="modal" data-target="#updateCustomMsg" style="visibility: hidden"
  id="updateCustomMsgBtn">
  Message
</button>
<div class="modal fade" id="updateCustomMsg" role="dialog">
  <div class="modal-dialog modal-sm" style="margin-top: 50px;">
    <div class="modal-content" style="margin: 0 auto;width: 450px;">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title" id="ancillary_update_header">{{custom_header}}</h4>
      </div>
      <div class="modal-body">
        <div class="inner-pnr">
          <span>{{custom_msg}} </span>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="deleteData()">
          Delete
        </button>
        <button type="button" class="btn btn-default" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>